import React, { Component, Fragment } from 'react';
import ReactCustomFlagSelect from './ReactCustomFlagSelect';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';
import staticData from './static';
import './App.css';
import plusIcon from "./img/plus1.png";
import minusIcon from "./img/minus1.png";
import 'react-responsive-modal/styles.css';

export default class EmployeeForm extends Component {

    constructor(props){
        super(props);
        this.pickMulti = React.createRef();
        this.validateForm =this.validateForm.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.urlParams = new URLSearchParams(window.location.search);
        this.sectionType = this.getSectionType();
        this.state = {
          passesScreenActive: true,
          fields: {
            areaCode: 1,
            areaCode2: 1,
            email: ''
          },
          userEmail: [{email: ''}],
          vehicleDetail: [{vehicle_no: '', vehicle_type: '', vehicle_make: '' }],
          errors: {},
          arenaId: this.urlParams.get('id'),
          setOpen: false,
          no_of_spots: 1,
          no_of_vehicles: 1,
          visible: this.urlParams.get('visible')
        };
    } 

    getSectionType() {
      if (this.props.isVIP) return "vip";
      if (this.props.isVendor) return "vendor";
      if (this.props.isFiu) return 'fiu';
      return 'employee';
    }
    
      handleAreaCode(areaCode){
        let fields = {...this.state.fields};
        fields['areaCode'] = areaCode;
        this.setState({ 
          fields 
        });
      }
    
      find(search, keys){
        if(!search) {
          return {
            "id": "1",
            "name": "US",
            "displayText": "United States (+1)",
            "country": "United States",
            "locale": "",
            "flag": `${URL.S3_BUCKET2}/FlagKit/US.imageset/US.png`
          }
        }
        var lowSearch = search.toLowerCase();
        return staticData.countryCode.filter(function(item){
            return keys.some( key => 
                String(item[key]).toLowerCase().includes(lowSearch) 
            );
        });
      }
    
      handleClose(){
        this.setState({booked: false, bookedID: null }, () => {
          this.manageBodyBackground(false);
        })
      }
    
      handleChange(e) {
        let fields = {...this.state.fields};
        fields[e.target.name] = e.target.value;
        this.setState({
            fields
        })
      }
    
      handleProfile(){
        this.setState({
          isSaveProfile: !this.state.isSaveProfile
        })
      }
    
      getFreq(){
          if(!this.state.fields["pass_type"]) return;
          this.state.passList.filter(item => item.pass_type === this.state.fields["pass_type"]).map(item => <option>{item.pric}</option>);
      }
    
      handleIncrement(){
        const arr = [...this.state.userEmail];
        arr.push({
          email: ''
        });
        
        this.setState({
          userEmail: arr
        })
      }
    
      handleDecrement(index){
          const arr = [...this.state.userEmail];
          arr.splice(index, 1);
          this.setState({
            userEmail: arr
          }, () => { 
            // console.log("===state===", this.state.discount)
          })
      }
    
      handleVehicleIncrement(){
        let count = this.state.no_of_vehicles + 1;
        const arr = [...this.state.vehicleDetail];
        arr.push({vehicle_no: '', vehicle_type: '', vehicle_make: '' });
        
        this.setState({
          no_of_vehicles: count,
          vehicleDetail: arr
        })
      }
    
      handleVehicleDecrement(index){
        if(this.state.no_of_vehicles > 1) {
          const arr = [...this.state.vehicleDetail];
          arr.splice(index, 1);
          this.setState({
            no_of_vehicles: this.state.no_of_vehicles - 1,
            vehicleDetail: arr
          }, () => { 
            // console.log("===state===", this.state.discount)
          })
        }  
      }
    
      handleVehicleChange(e, index){
        const arr = [...this.state.vehicleDetail];
        arr[index][e.target.name] = e.target.name === 'vehicle_no' && e.target.value ? e.target.value.toUpperCase() : e.target.value;
        this.setState({
          vehicleDetail: arr
        })
      }
    
      handleUserEmailChange(e, index){
        
        const arr = [...this.state.userEmail];
          arr[index]['email'] = e.target.value;
          this.setState({
            userEmail: arr
          })
      }
    
      handleSpotIncrement() {
        let count = this.state.no_of_spots + 1;
        this.setState({
          no_of_spots: count,
          userEmail: [...this.state.userEmail, {email: ''}]
        }, () => {
          this.props.calculateAccountPrice();
        })
      }
    
      handleSpotDecrement() {
        if(this.state.no_of_spots > 1) {
        this.setState({
          no_of_spots: this.state.no_of_spots - 1,
          userEmail: this.state.userEmail.slice(0, -1)
        }, () => {
            this.props.calculateAccountPrice();
        })}
      }
    
      getMonthlyPrice(){
        return this.props.selectedPass && this.props.selectedPass.pricing_data ? '$' + this.props.selectedPass.pricing_data.rental_fee/100 : '';
      }
    
      getVehicleDetail(){
        return this.state.vehicleDetail.map((item, index) => {
          const isLicenseSpecialChar = item.vehicle_no && this.nonSpecialCharacterForValue(item.vehicle_no); 
          const wrap = (<div id="vehicle-detail-wrap">
                          <div className='vehicle-detail'>Vehicle {index + 1}</div>
                          <div className="upper">
                              <span>License Plate <i>*</i> </span>
                              <input
                                style={{textTransform: 'uppercase'}}
                                className="pay-fields" 
                                value={item.vehicle_no}
                                name="vehicle_no"
                                onChange={(e) => this.handleVehicleChange(e, index)}
                                maxLength="100"
                              />
                              {!isLicenseSpecialChar && this.state.errors["vehicle_detail"] && !item.vehicle_no && <div className="error-msg">enter your license plate</div>}
                              {isLicenseSpecialChar && <div className="error-msg">special characters are not allowed</div>}
                          </div>
                          <div className="upper">
                              <span>Vehicle Make <i>*</i> </span>
                              <input
                                className="pay-fields" 
                                value={item.vehicle_make}
                                name="vehicle_make"
                                onChange={(e) => this.handleVehicleChange(e, index)}
                                maxLength="100"
                              />
                              {this.state.errors["vehicle_detail"] && !item.vehicle_make && <div className="error-msg">enter your vehicle make</div>}
                          </div>
                          {<div className="upper">
                            <span>Vehicle Color <i>*</i></span>
                            <input
                              className="pay-fields" 
                              value={item["vehicle_color"]}
                              name="vehicle_color"
                              onChange={(e) => this.handleVehicleChange(e, index)}
                              maxLength={150}
                            />
                            {this.state.errors["vehicle_detail"] && !item.vehicle_color &&  <div className="error-msg">enter your vehicle color</div>}
                          </div>}
                        </div>);
          return wrap;
        })                  
      }
    
      handleProfile(){
        this.setState({
          isSaveProfile: !this.state.isSaveProfile
        })
      }
      
      nonSpecialCharacter(name){
        let fields = this.state.fields;
        return !/[!@#$%^&*()\-_=+\[\]{}|;:'",<.>/?]/g.test(fields[name]);
      }
    
      nonSpecialCharacterForValue(value){
       return /[!@#$%^&*()\-_=+\[\]{}|;:'",<.>/?]/g.test(value);
      }
    
      onlyZip(name){
        let fields = this.state.fields;
        if(!fields[name].match(/^[0-9]{5}$/)){
          return false;
        }
        return true;
      }
    
      onlyPhone(name){
        let fields = this.state.fields;
        if(!fields[name].match(/^[0-9]*$/)){
          return false;
        }
        return true;
      }
    
      onlyEmail(name){
        let fields = this.state.fields;
        if(!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(fields[name])){
          return false;
        }
        return true;
      }
    
      onlyUserEmail(value){
        if(!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(value)){
          return false;
        }
        return true;
      }
    
      validateForm(){
        let fields = this.state.fields;
        let formIsValid = true;
        this.errors = {};
        const cardWrapper = document.querySelector('#card-element');
        const cardWrapperError = document.querySelector('#card-errors');
    
        if (!fields["first_name"] || (fields["first_name"] && fields["first_name"].trim() === '')) {
          formIsValid = false;
          this.errors["first_name"] = "enter your first name";
        }
        if (!fields["last_name"] || (fields["last_name"] && fields["last_name"].trim() === '')) {
          formIsValid = false;
          this.errors["last_name"] = "enter your last name";
        }
        if (this.sectionType !== 'fiu' && (!fields["company_name"] || (fields["company_name"] && fields["company_name"].trim() === ''))) {
          formIsValid = false;
          this.errors["company_name"] = "enter your company name";
        }
        if (!fields["phone1"] || (fields["phone1"] && fields["phone1"].trim() === '')) {
          formIsValid = false;
          this.errors["phone1"] = "enter your mobile number";
        }
        if (typeof fields["phone1"] !== "undefined") {
          const isValid = this.onlyPhone("phone1");
          if (!isValid) {
            formIsValid = false;
            this.errors["phone1"] = "enter a valid mobile number";
          }
        }
        if (!fields["email"] || (fields["email"] && fields["email"].trim() === '')) {
          formIsValid = false;
          this.errors["email"] = "enter your email address";
        }
        if (fields["email"] != '' && fields["email"].trim() != '') {
          const isValid = this.onlyEmail("email");
          if (!isValid) {
            formIsValid = false;
            this.errors["email"] = "enter a valid admin email address";
          }
        }
    
        let arrOfVD = this.state.vehicleDetail
            for (var i = 0; i < arrOfVD.length; i++) {
            let isVehicleFieldEmpty = ((!arrOfVD[i].vehicle_no || !arrOfVD[i].vehicle_make || !arrOfVD[i].vehicle_color) || (arrOfVD[i].vehicle_no && this.nonSpecialCharacterForValue(arrOfVD[i].vehicle_no)));
            if (isVehicleFieldEmpty) {
                formIsValid = false;
                this.errors["vehicle_detail"] = "incomplete";
                break;
            }
        } 
    
        this.setState({
          errors: this.errors
        });
        return formIsValid;
      }

    
      handlePreSubmit(e){
        if(e) e.preventDefault();
        const isValid = this.validateForm();
        if(!isValid) return;
        let { fields } = this.state;
        let basic = {
            parking_id: this.props.parkingId ? parseInt(this.props.parkingId) : '', 
            first_name: fields.first_name,
            last_name: fields.last_name,
            country_code: '+' + fields.areaCode,
            contact_number: fields.phone1,
            company_name: this.sectionType === 'fiu' ? 'fiu' : fields.company_name,
            email: fields.email,
            category: this.sectionType,
            free_parking: true,
            status: "active",
            save_profile: false,
            vehicle_sharing: false,
            external_user_id: "self"
        }
        let request = this.state.vehicleDetail.map(item => { return {...item, ...basic, vehicle_no: item.vehicle_no?.replace(/\s/g, "").replace(/\\/g, '')}});
        this.props.handleSubmit(null, null, null, {data: request});
      }

  render() {
      
    let { fields } = this.state; 
    const vehicleCount = this.state.vehicleDetail ? this.state.vehicleDetail.length : 1;
    const totalAmt = fields.reserve_spot == 'true' ? vehicleCount * ((this.state.convFee + this.state.reservedSpot)/100) : vehicleCount * ((this.state.convFee + this.state.rentalFee)/100); 
    
    return (
        <div className='monthly-consumer'>
          <form onSubmit={this.handlePreSubmit.bind(this)} className="individual" style={{pointerEvents: this.state.booked || this.state.seeMore ? 'none' : 'auto', visibility: this.state.booked ? 'hidden' : 'visible'}} action="#" method="POST">
            <input type="hidden" name="token" />
            <p style={{textAlign:'center', marginBottom: '5px', color: '#333', borderBottom: '1px solid #666565', paddingBottom: '10px'}}><b>{this.sectionType == 'fiu' || this.sectionType == 'vip' ? this.sectionType.toUpperCase() : this.sectionType[0].toUpperCase() + this.sectionType.slice(1)} Registration</b></p>
            <p style={{color: '#666565', marginTop: '10px'}}>Please enter the following info as part of your registration.</p>
            <div className="upper">
                <span>First Name <i>*</i></span>
                <input
                  className="pay-fields" 
                  value={this.state.fields["first_name"]}
                  name="first_name"
                  onChange={this.handleChange}
                  maxLength={150}
                />
                <div className="error-msg">{this.state.errors['first_name']}</div>
            </div>
            <div className="upper">
                <span>Last Name <i>*</i> </span>
                <input
                  className="pay-fields" 
                  value={this.state.fields["last_name"]}
                  name="last_name"
                  onChange={this.handleChange}
                  maxLength={150}
                />
                <div className="error-msg">{this.state.errors['last_name']}</div>
            </div>
            <div className="upper">
              <span>Mobile <i>*</i></span>
              <div className="country-with-phone">
                <div className="country-code">
                    <ReactCustomFlagSelect
                      showSearch={false} 
                      showArrow={true} 
                      animate={true} 
                      value={this.state.fields['areaCode']}
                      customStyleOptionListContainer={{ maxHeight: '200px', overflow: 'auto', width: '240px', marginTop: '11px' }}
                      optionList={staticData.countryCode} 
                      onChange={areaCode => {
                        this.handleAreaCode(areaCode);
                      }}
                    />
                </div>
                <div className="input-wrapper">
                    <input
                      className="pay-fields mobile-input" 
                      value={this.state.fields["phone1"]}
                      name="phone1"
                      onChange={this.handleChange}
                      maxLength={15}
                    />
                </div>
                <div style={{clear: 'both'}}></div>
              </div>
              <div className="error-msg">{this.state.errors['phone1']}</div>
            </div>
            <div className="upper">
              <span>Email <i>*</i></span>
              <input
                className="pay-fields" 
                value={this.state.fields["email"]}
                name="email"
                onChange={this.handleChange}
                maxLength={250}
              />
              <div className="error-msg">{this.state.errors['email']}</div>
            </div>
            {this.sectionType !== 'fiu' && <div className="upper">
              <span>Company Name <i>*</i></span>
              <input
                className="pay-fields" 
                value={this.state.fields["company_name"]}
                name="company_name"
                onChange={this.handleChange}
                maxLength={150}
              />
              <div className="error-msg">{this.state.errors['company_name']}</div>
            </div>}
            <div className="upper">
              <span>No. Of Vehicles <i>*</i></span>
              <div className='no-of-spot'>
                <img style={{right: '-4px'}} className='add-delete-icon' onClick={this.handleVehicleIncrement.bind(this)} src={plusIcon} />  
                <input className='jumbotron__window' type="number" value={this.state.no_of_vehicles} min='1'/>
                <img className='add-delete-icon' onClick={this.handleVehicleDecrement.bind(this)} src={minusIcon} /> 
              </div>
              <div className="error-msg">{this.state.errors['no_of_vehicles']}</div>
            </div>
            <div>
              {this.getVehicleDetail()}
            </div> 
            <button style={{width: this.state.isPayment ? '100%' : '150px'}} id="pay-submit" type="submit">Register</button>
            <div style={{clear: 'both'}} />
          </form>
        </div>
    )
  }
}

